import { render, staticRenderFns } from "./IconArrow.vue?vue&type=template&id=71560aaa&scoped=true"
import script from "./IconArrow.vue?vue&type=script&lang=ts"
export * from "./IconArrow.vue?vue&type=script&lang=ts"
import style0 from "./IconArrow.vue?vue&type=style&index=0&id=71560aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71560aaa",
  null
  
)

export default component.exports